<template>
  <div class="w-100">
    <div class="w-100 position-relative" :class="$is_mobile_view ? 'h-200px' : 'h-240px'">
      <div @click="closeDetail()" class="close-btn">
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.261089 15.749C0.614234 16.0921 1.19944 16.0921 1.5425 15.749L8.00002 9.2915L14.4575 15.749C14.8006 16.0921 15.3959 16.1022 15.7389 15.749C16.082 15.3959 16.082 14.8208 15.7389 14.4777L9.28143 8.01011L15.7389 1.55259C16.082 1.20954 16.0921 0.624325 15.7389 0.281269C15.3858 -0.0718766 14.8006 -0.0718766 14.4575 0.281269L8.00002 6.73879L1.5425 0.281269C1.19944 -0.0718766 0.604144 -0.0819664 0.261089 0.281269C-0.0819664 0.634414 -0.0819664 1.20954 0.261089 1.55259L6.7186 8.01011L0.261089 14.4777C-0.0819664 14.8208 -0.0920566 15.406 0.261089 15.749Z" fill="white"></path></svg>
      </div>
      <img :src="product.image_url" class="img-fit">
    </div>
    <div class="p-md-4 p-3">
      <div class="d-flex justify-content-between">
        <div>
          <p class="mb-1" :class="$is_mobile_view ? 'body-2-4' : 'sub-heading-1-2'">{{ product.name }}</p>
          <p class="mb-2 html-desc text-truncate-2" style="max-height: 38px" :class="$is_mobile_view ? 'body-3' : 'body-2'" v-html="product.description"></p>
    
          <ul class="pl-3 my-2 mb-4">
            <li v-if="$isNotEmptyV2(product.display.routeType)" class="mb-0" :class="$is_mobile_view ? 'body-3-1' : 'body-2-1'">{{ product.display.routeType }}</li>
            <li v-if="$isNotEmptyV2(product.display.passenger)" class="mb-0" :class="$is_mobile_view ? 'body-3-1' : 'body-2-1'">{{ product.display.passenger }}</li>
          </ul>
        </div>
        <div class="text-right pl-3">
          <p class="mb-1 font-lato lh-1" :class="$is_mobile_view ? 'text-22' : 'text-26'">{{ $formatCurrency(product.price) }}</p>
          <p class="mb-1 body-3-1 lh-1">/ {{product.unit.unit}}</p>
        </div>
      </div>
      
      <div class="w-100 border-form bg-light-page rounded-6 mb-4">
        <template v-if="$isNotEmptyV2(rooms)">
          <div v-for="(room,roomIndex) in rooms" class="px-2 px-md-3 d-flex align-items-center justify-content-between" :class="{'border-b-form' : roomIndex+1 < rooms.length, 'py-2-5' : !$is_mobile_view, 'py-2' : $is_mobile_view}">
            <div class="w-100">
              <p class="mb-1 body-2-4">{{ room.room_rate.name }}</p>
              <p class="mb-0 body-3">{{ room.display.guest }}</p>
            </div>
            <div class="flex-shrink-0">
              <p class="w-100 text-center font-lato text-16 mb-1 text-orange">{{ $formatCurrency(room.display.qty * Number(product.price)) }}</p>
              <div class="d-flex align-items-center justify-content-between bg-white border-form rounded-6">
                <div @click="decreaseRoomQty(roomIndex)" class="text-center" style="width: 28px; height: 28px;">
                  <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1.71429H0V0H12V1.71429Z" fill="black" fill-opacity="0.54"/>
                  </svg>
                </div>
                <p style="width: 36px;" class="mb-0 font-lato text-center text-14">{{ room.display.qty }}</p>
                <div @click="increaseRoomQty(roomIndex)" class="text-center" style="width: 28px; height: 28px;">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 6.85714H6.85714V12H5.14286V6.85714H0V5.14286H5.14286V0H6.85714V5.14286H12V6.85714Z" fill="black" fill-opacity="0.54"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div class="p-2 p-md-3 text-center" v-else>
          <p class="mb-0 body-2-2" v-html="paxCategoryNotMatchedMessage"></p>
        </div>
      </div>
      
      <div class="d-flex flex-column flex-md-row align-items-end align-items-md-center justify-content-between" v-if="$isNotEmptyV2(rooms)">
        <div class="mb-3 mb-md-0 text-right text-md-left">
          <template v-if="totalPrice > 0">
            <p class="mb-1 w-100 text-orange font-lato lh-1" :class="$is_mobile_view ? 'text-22' : 'text-26'">{{ $formatCurrency(totalPrice) }}</p>
            <p class="mb-0 w-100 body-3-1 lh-1">for {{ totalPassenger }} passengers</p>
          </template>
        </div>
        <div class="d-flex justify-content-end">
          <button @click="closeDetail()" class="g-btn g-btn-md g-btn-white rounded border-form py-2 px-4">
            Cancel
          </button>
          <state-button class="ml-3 g-btn g-btn-md g-btn-primary rounded py-2 px-4" variant="primary" size="md" block :click="submitProduct">
            Confirm
          </state-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    props: ['product'],
    data(){
      return{
        rooms: []
      }
    },
    computed:{
      ...mapGetters(['getBeCart']),
      paxCategory(){
        if(this.$isEmpty(this.product)) return '';
        const { cm_transport_pax_category = null } = this.product
        return this.$isEmpty(cm_transport_pax_category) ? "ALL" : cm_transport_pax_category;
      },
      paxCategoryNotMatchedMessage(){
        const isInfantPax = this.paxCategory === 'INFANT';
        const paxText = isInfantPax ? ["infants", "infant"] : ["children", "child"];
        
        return `This transport option is available for <b>${paxText[0]} only</b>, but your reservation has <b>no ${paxText[1]} passengers.</b>`
      },
      totalPrice(){
        if(this.$isEmpty(this.rooms)) return 0;
        return this.rooms.reduce((sum,val) => (val.display.qty * Number(this.product.price)) + sum, 0);
      },
      totalPassenger(){
        if(this.$isEmpty(this.rooms)) return 0;
        return this.rooms.reduce((sum,val) => val.display.qty + sum, 0);
      }
    },
    mounted(){
      this.getRooms();
    },
    methods:{
      ...mapMutations(['saveAdditionalProductToRoom']),
      getRooms(){
        this.rooms = [];
        const savedRooms = this.$deepCopy(this.getBeCart.room_rate_details);

        savedRooms.forEach(room => {
          const { room_rate, qty, guest } = room;

          for (let i = 0; i < guest.length; i++) {
            if(this.$isEmpty(guest[i])) continue;
            
            const { included, extra } = guest[i];
            const totalGuestsObj = this.$sumByKeys(included, extra)
            const totalGuests = Object.values(totalGuestsObj).reduce((sum, value) => sum + value, 0);

            const isAllPaxValid = this.paxCategory == 'ALL' && totalGuests > 0;
            const isAdultValid = this.paxCategory == 'ADULT' && totalGuestsObj.adult > 0;
            const isChildValid = this.paxCategory == 'CHILD' && totalGuestsObj.child > 0;
            const isInfantValid = this.paxCategory == 'INFANT' && totalGuestsObj.infant > 0;
            
            
            if(isAllPaxValid || isAdultValid || isChildValid || isInfantValid){
              let qty =  0 
              if(this.$isNotEmptyV2(guest[i].products)){
                const selectedProduct = guest[i].products.find(prd => prd.data.id === this.product.id);
                if(selectedProduct) qty = selectedProduct.qty
              }
              
              
              this.rooms.push({
                room_rate,
                guest: guest[i],
                guestIndex: i,
                display: {
                  guest: this.generateGuest(totalGuestsObj),
                  totalGuest: this.paxCategory == 'ALL' ? totalGuests : totalGuestsObj[this.paxCategory.toLowerCase()],
                  qty
                }
              })
            }
          }
        });
      },
      generateGuest(totalGuest){
        const GUEST_KEY = [
          {key: 'adult', text: 'Adult', plural: 'Adults'},
          {key: 'child', text: 'Child', plural: 'children'},
          {key: 'infant', text: 'Infant', plural: 'Infant'},
        ];

        if(this.paxCategory === 'ALL'){
          const finalGuests = [];
          GUEST_KEY.forEach(gst => {
            const { key, text, plural } = gst;
            const guest = totalGuest[key];
            if(guest > 0){
              const guestText = `${guest} ${guest > 1 ? plural : text}`;
              finalGuests.push(guestText);
            }
          });
          return this.$isNotEmptyV2(finalGuests) ? finalGuests.join(', ') : ""
        }else{
          const key = this.paxCategory.toLowerCase();
          const total = totalGuest[key];
          const guest = GUEST_KEY.find(gst => gst.key === key);
          return `${total} ${total > 1 ? guest.plural : guest.text}`
        }
        
      },
      decreaseRoomQty(roomIndex){
        const room = this.rooms[roomIndex];
        if(room.display.qty === 0) return;
        this.$set(room.display, 'qty', (room.display.qty || 0) - 1);
      },
      increaseRoomQty(roomIndex){
        const room = this.rooms[roomIndex];
        const { totalGuest, qty } = this.rooms[roomIndex].display
        if(qty === totalGuest) return;
        this.$set(room.display, 'qty', (room.display.qty || 0) + 1);
      },
      closeDetail(){
        this.$emit('close', null)
      },
      submitProduct(){
        return new Promise((resolve, reject) => {
          try {
            const productParams = this.rooms.map(room => {
              const { room_rate: { id : roomId }, guestIndex, display: { qty }} = room;
              return { roomId, guestIndex, product: this.product, qty}
            })
            console.log("🚀 ~ productParams:", productParams)
            
            productParams.forEach((param, index) => {
              this.saveAdditionalProductToRoom(param);
              
              if(index + 1 === productParams.length){
                setTimeout(() => {
                  this.closeDetail()
                  resolve();
                }, 300);
              }
            })
          } catch (error) {
            console.log("ERROR submitProduct : ", error.message)
            resolve();
          }
        });
      },
      generateProductParams(){
        const validRooms = this.rooms.filter(room => room.display.qty > 0);
        if(this.$isEmpty(validRooms)) return [];  

        return validRooms.map(room => {
          const { room_rate: { id : roomId }, guestIndex, display: { qty }} = room;
          return { roomId, guestIndex, qty}
        })
        
      }
    }
  }
</script>
<style>
.close-btn{
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  top: 16px;
  right: 16px;
  text-align: center;
  place-items: center;
  display: grid;
  background-color: rgba(0, 0, 0, 0.5);
}
.h-240px{
  height: 240px;
}
.h-200px{
  height: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/TransportServicesProductDetail.vue